/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ObjectSchema } from 'yup';
import { useParams } from 'react-router-dom';
import { SiteForm, assignSiteDetailsValues } from '../utils/helpers';
import ComponentEditSiteMethods from './ComponentEditSiteMethods';
import { MainFormValues } from '../utils/types';
import { mainFormSchema, mainFormSchemaNonMand } from '../utils/validations';
import { MainDefaultValue } from '../utils/constants';
import { setLoader } from '../../../redux/loaderSlice';
import { RootState } from '../../../redux/rootState';
import { getSiteByIdStart, getSiteTypeStart, resetSiteState } from '../redux/sliceSites';
import { getPinCodeDetailsStart, removePinCodeDetails, resetCityStateSuggestion } from '../../../redux/masters/masterSlice';

function ComponentEditSite() {
  const dispatch = useDispatch();
  const { siteId } = useParams();
  const [enableSetState, setEnableSetState] = useState(false);

  const { siteDetailsById, isLoading } = useSelector((state: RootState) => state.siteReducer);
  const { pinCodeDetails } = useSelector((state: RootState) => state.masterDataReducer);

  const {
    control, handleSubmit, formState: { errors }, watch, setValue, trigger, getValues, setError,
  } = useForm<MainFormValues>({
    resolver: yupResolver((siteDetailsById?.CountryCode === 'US' ? mainFormSchema : mainFormSchemaNonMand) as unknown as ObjectSchema<MainFormValues>),
    defaultValues: MainDefaultValue,
  });

  const siteZip = watch(SiteForm.zip);
  // const countryName = watch(SiteForm.country);

  // useEffect(() => {
  //   if (siteZip && siteZip?.length >= 5) {
  //     dispatch(removePinCodeDetails());
  //     setValue(SiteForm.state, '');
  //     // setValue(SiteForm.city, '');
  //     const queryPayload = {
  //       pinCode: siteZip,
  //       countryCode: getValues(SiteForm.country),
  //     };
  //     dispatch(getPinCodeDetailsStart(queryPayload));
  //   } else if (siteZip?.length < 5) {
  //     dispatch(removePinCodeDetails());
  //     setValue(SiteForm.state, '');
  //     // setValue(SiteForm.city, '');
  //   }
  // }, [siteZip, countryName]);
  const handleZipChange = (_e: string, text: string) => {
    setEnableSetState(true);
    if (text && text?.length >= 5) {
      dispatch(removePinCodeDetails());
      dispatch(resetCityStateSuggestion());
      setValue(SiteForm.state, '');
      const queryPayload = {
        pinCode: text,
        countryCode: getValues(SiteForm.country),
      };
      dispatch(getPinCodeDetailsStart(queryPayload));
    } else if (text?.length < 5) {
      dispatch(removePinCodeDetails());
      dispatch(resetCityStateSuggestion());
      setValue(SiteForm.state, '');
    }
  };
  useEffect(() => {
    if (siteDetailsById?.Pincode && siteDetailsById?.Pincode?.length >= 5 && !enableSetState) {
      dispatch(removePinCodeDetails());
      dispatch(resetCityStateSuggestion());
      // setValue(SiteForm.city, '');
      const queryPayload = {
        pinCode: siteDetailsById?.Pincode,
        countryCode: getValues(SiteForm.country),
      };
      dispatch(getPinCodeDetailsStart(queryPayload));
    }
  }, [siteDetailsById]);
  const handleCountryChange = (text: string) => {
    dispatch(removePinCodeDetails());
    setValue(SiteForm.country, text);
    setValue(SiteForm.zip, '');
    handleZipChange('', '');
  };

  useEffect(() => {
    if (pinCodeDetails?.City && siteZip && enableSetState) {
      setValue(SiteForm.state, pinCodeDetails.StateName);
      trigger([SiteForm.state]);
    }
  }, [pinCodeDetails]);

  useEffect(() => {
    if (siteId) {
      const payload = {
        siteId: String(siteId),
      };
      dispatch(getSiteByIdStart(payload));
    }
    return () => {
      dispatch(resetSiteState());
    };
  }, [siteId]);

  useEffect(() => {
    if (siteDetailsById.SiteId) {
      assignSiteDetailsValues(siteDetailsById, setValue);
    }
  }, [siteDetailsById]);

  useEffect(() => {
    dispatch(getSiteTypeStart());
  }, [siteId]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  return (
    <ComponentEditSiteMethods
      control={control}
      errors={errors}
      watch={watch}
      setValue={setValue}
      handleSubmit={handleSubmit}
      setError={setError}
      trigger={trigger}
      handleZipChange={handleZipChange}
      handleCountryChange={handleCountryChange}
      enableSetState={enableSetState}
    />
  );
}

export default ComponentEditSite;
